import { ArticleParagraph1, ArticleParagraph2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { HELP_CENTER_LINK_FAQ } from '../../constants/links';
import * as styles from './HelpLinks.css';
import { LinkButton, Spinner } from '@cian/ui-kit';
import { ETag } from '../../types/feedbackFormSettings';
import { Link } from '../Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HelpLinks = function HelpLinks(_ref) {
  var isLoading = _ref.isLoading,
    header = _ref.header,
    elements = _ref.elements,
    onFaqLinkClick = _ref.onFaqLinkClick,
    onHelpCenterLinkClick = _ref.onHelpCenterLinkClick;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: isLoading ? /*#__PURE__*/_jsx("div", {
      className: styles['spinner'],
      children: /*#__PURE__*/_jsx(Spinner, {
        size: 48,
        color: "primary_100",
        display: "flex"
      })
    }) : /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: /*#__PURE__*/_jsx(ArticleParagraph1, {
          children: header
        })
      }), /*#__PURE__*/_jsxs("ul", {
        className: styles['rows'],
        children: [elements.map(function (_ref2) {
          var tag = _ref2.tag,
            text = _ref2.text,
            link = _ref2.link;
          if (tag === ETag.A && link) {
            return /*#__PURE__*/_jsx("li", {
              className: styles['row'],
              children: /*#__PURE__*/_jsx(Link, {
                href: encodeURI(link),
                target: "_blank",
                size: "XS",
                onClick: function onClick() {
                  return onFaqLinkClick(text);
                },
                children: text
              })
            }, "help_link_".concat(text));
          }
          if (tag === ETag.Div) {
            return /*#__PURE__*/_jsx("li", {
              className: styles['row'],
              children: text
            }, "help_text_".concat(text));
          }
          return;
        }), /*#__PURE__*/_jsx("li", {
          className: styles['button'],
          children: /*#__PURE__*/_jsx(ArticleParagraph2, {
            children: /*#__PURE__*/_jsx(LinkButton, {
              theme: "fill_secondary",
              href: HELP_CENTER_LINK_FAQ,
              target: "_blank",
              size: "XS",
              onClick: onHelpCenterLinkClick,
              children: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B"
            })
          })
        })]
      })]
    })
  });
};